import {customElement, property} from "lit/decorators.js";
import {FormInputElement} from "./formInputElement";
import {html, type TemplateResult} from "lit";
import Styles from "./formToggleLink.lit.scss";
import {noop} from "../../../common/utils/functions";

@customElement("eop-form-toggle-link")
export class EopFormToggleLink extends FormInputElement<boolean> {

    public static readonly styles = Styles;

    @property({attribute: "label-check"})
    private labelCheck: string;
    @property({attribute: "label-uncheck"})
    private labelUncheck: string;

    public constructor() {
        super(false);
    }

    public render(): TemplateResult {
        return html`<a @click=${this.toggle}>${this.getLabel()}</a>`;
    }

    private toggle(): void {
        this.updateValue(!this.value);
    }

    private getLabel(): string {
        return this.value
            ? this.labelUncheck
            : this.labelCheck;
    }

    protected preset(): boolean {
        return false;
    }

    public focusInput(): void {
        noop();
    }
}